import React from 'react'
import { Card, Table, Pagination } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getUserAddressListAPI } from '@/apis/user'
const { Column } = Table
import Dayjs from 'dayjs'

export default function AddressList() {
  const location = useParams()
  const userId = location.userid
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  const [listQuery, setListQuery] = useState({
    userId,
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  楼盘总数
  const [list, setList] = useState(0) //  楼盘列表

  //  楼盘列表
  const fetchData = async () => {
    setListLoading(true)
    const res = await getUserAddressListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          let week = Dayjs(item.addressTime).format('d')
          let hour = Dayjs(item.addressTime).format('H')
          let weekTxt = ''
          if (week === 6 || week === 0) {
            weekTxt = '休息日'
          } else {
            weekTxt = '工作日'
          }
          let hourTxt = ''
          if (hour < 6) {
            hourTxt = '凌晨'
          } else if (hour < 9) {
            hourTxt = '​​早晨​​'
          } else if (hour < 18) {
            hourTxt = '​​白天'
          } else {
            hourTxt = '晚间'
          }
          item.timeType = weekTxt + ' ' + hourTxt
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div>
      <Card className="card" title="位置记录">
        <Table dataSource={list} loading={listLoading} pagination={false} rowKey="key">
          <Column
            title="授权位置"
            key="action"
            render={(_, record) => (
              <span>{record.province + record.city + record.address}</span>
            )}
          />
          <Column title="授权位置" dataIndex="address" />
          <Column title="授权时间" dataIndex="addressTime" />
          <Column title="特征" dataIndex="timeType" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
